import { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

export default function VisitorCounter() {
  const [data, setData] = useState({ total: 0, today: 0 });
  const [mini, setMini] = useState(false);

  /* ================= VISITOR LOGIC (TIDAK DIUBAH) ================= */
  useEffect(() => {
    const countVisitor = async () => {
      try {
        const ref = doc(db, "visitors", "summary");
        const snap = await getDoc(ref);
        const today = new Date().toISOString().slice(0, 10);

        if (!snap.exists()) {
          await setDoc(ref, {
            total: 1,
            today: 1,
            lastDate: today,
          });
          setData({ total: 1, today: 1 });
          return;
        }

        const d = snap.data();

        if (d.lastDate !== today) {
          await updateDoc(ref, {
            total: d.total + 1,
            today: 1,
            lastDate: today,
          });
          setData({ total: d.total + 1, today: 1 });
        } else {
          await updateDoc(ref, {
            total: d.total + 1,
            today: d.today + 1,
          });
          setData({ total: d.total + 1, today: d.today + 1 });
        }
      } catch (err) {
        console.error("Visitor error:", err);
      }
    };

    countVisitor();
  }, []);

  /* ================= RESPONSIVE MINI MODE ================= */
  useEffect(() => {
    const resize = () => setMini(window.innerWidth < 768);
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  /* ================= UI ================= */
  return (
    <div style={styles.wrapper}>
      {mini ? (
        /* ===== MINI MODE (MOBILE) ===== */
        <div style={styles.mini} title="Pengunjung Hari Ini">
          👥 {data.today.toLocaleString("id-ID")}
        </div>
      ) : (
        /* ===== FULL MODE (DESKTOP) ===== */
        <div style={styles.card}>
          <div style={styles.icon}>👀</div>
          <div>
            <div style={styles.total}>
              {data.total.toLocaleString("id-ID")}
            </div>
            <div style={styles.label}>Total Pengunjung</div>
            <div style={styles.today}>
              Hari ini: {data.today.toLocaleString("id-ID")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ================= STYLE ================= */
const styles = {
  wrapper: {
    position: "fixed",
    bottom: 20,
    left: 20, // 🔥 pindah ke kiri biar aman
    zIndex: 9999,
  },

  card: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    background: "linear-gradient(135deg, #0d6efd, #00c6ff)",
    color: "white",
    padding: "16px 20px",
    borderRadius: 18,
    boxShadow: "0 12px 30px rgba(0,0,0,.25)",
    cursor: "default",
    transition: "transform .3s, box-shadow .3s",
  },

  icon: {
    fontSize: 42,
    filter: "drop-shadow(0 3px 6px rgba(0,0,0,.3))",
  },

  total: {
    fontSize: 28,
    fontWeight: "bold",
    lineHeight: 1,
  },

  label: {
    fontSize: 13,
    opacity: 0.9,
  },

  today: {
    fontSize: 12,
    marginTop: 4,
    opacity: 0.85,
  },

  /* ===== MINI MODE STYLE ===== */
  mini: {
    background: "linear-gradient(135deg, #0d6efd, #00c6ff)",
    color: "white",
    padding: "10px 14px",
    borderRadius: 999,
    fontSize: 14,
    fontWeight: "bold",
    boxShadow: "0 8px 20px rgba(0,0,0,.3)",
    cursor: "pointer",
  },
};
